import {useLazyQuery} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import type {Prompt} from '@cp/model';
import {GENERATE_QUESTION_GRAPH_JSON_PROMPTS} from '../sharedQueries';

export interface GenerateQuestionGraphJsonPromptsVariables {
  questionText: string;
  topic?: string;
  difficulty?: number;
  hint?: string;
  options?: string[];
  answer?: string;
  explanation?: string;
}

export function useGenerateQuestionGraphJsonPrompts() {
  const [generatePrompts, {loading, error}] = useLazyQuery<
    {generateQuestionGraphJsonPrompts: Prompt},
    GenerateQuestionGraphJsonPromptsVariables
  >(GENERATE_QUESTION_GRAPH_JSON_PROMPTS);

  const generateQuestionGraphJsonPrompts = async (variables: GenerateQuestionGraphJsonPromptsVariables) => {
    const result = await generatePrompts({variables});
    return extractGqlData(result).generateQuestionGraphJsonPrompts;
  };

  return {
    generateQuestionGraphJsonPrompts,
    loading,
    error,
  };
}
